/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadPalReportToExternalEhrConfig
 */
export interface UploadPalReportToExternalEhrConfig {
    /**
     * 
     * @type {string}
     * @memberof UploadPalReportToExternalEhrConfig
     */
    external_ehr_type: UploadPalReportToExternalEhrConfigExternalEhrTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UploadPalReportToExternalEhrConfig
     */
    upload: boolean;
}


/**
 * @export
 */
export const UploadPalReportToExternalEhrConfigExternalEhrTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH'
} as const;
export type UploadPalReportToExternalEhrConfigExternalEhrTypeEnum = typeof UploadPalReportToExternalEhrConfigExternalEhrTypeEnum[keyof typeof UploadPalReportToExternalEhrConfigExternalEhrTypeEnum];


/**
 * Check if a given object implements the UploadPalReportToExternalEhrConfig interface.
 */
export function instanceOfUploadPalReportToExternalEhrConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "external_ehr_type" in value;
    isInstance = isInstance && "upload" in value;

    return isInstance;
}

export function UploadPalReportToExternalEhrConfigFromJSON(json: any): UploadPalReportToExternalEhrConfig {
    return UploadPalReportToExternalEhrConfigFromJSONTyped(json, false);
}

export function UploadPalReportToExternalEhrConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPalReportToExternalEhrConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'external_ehr_type': json['external_ehr_type'],
        'upload': json['upload'],
    };
}

export function UploadPalReportToExternalEhrConfigToJSON(value?: UploadPalReportToExternalEhrConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'external_ehr_type': value.external_ehr_type,
        'upload': value.upload,
    };
}

